/*
 * Copyright 2020 Google Inc. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Message from './Message';
import MessageHeader from './MessageHeader';
export default class MessageChannel {
    constructor(transport, options, listener) {
        this.transport = transport;
        this.options = options;
        this.listener = listener;
        this.active = true;
        this.readLoop();
    }
    readLoop() {
        return __awaiter(this, void 0, void 0, function* () {
            let message;
            do {
                message = yield this.read();
                if (this.options.debug) {
                    console.log('<<<', message);
                }
                this.listener.newMessage(message);
            } while (this.active);
        });
    }
    readHeader() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.transport.read(24);
            return MessageHeader.parse(response, this.options.useChecksum);
        });
    }
    read() {
        return __awaiter(this, void 0, void 0, function* () {
            const header = yield this.readHeader();
            let receivedData;
            switch (header.cmd) {
                default: {
                    if (header.length > 0) {
                        receivedData = yield this.transport.read(header.length);
                    }
                }
            }
            const message = new Message(header, receivedData);
            return message;
        });
    }
    close() {
        this.active = false;
    }
    write(m) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.options.debug) {
                console.log('>>>', m);
            }
            const data = m.header.toDataView();
            yield this.transport.write(data.buffer);
            if (m.data) {
                yield this.transport.write(m.data.buffer);
            }
        });
    }
}
//# sourceMappingURL=MessageChannel.js.map